module.exports = __webpack_public_path__ + "img/522711b.jpg";